import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { ModalModule } from "ngx-modal";
import { LeadExportLogsModalComponent } from "./lead-export-logs-modal.component";

@NgModule({
  imports: [CommonModule, FormsModule, ModalModule],
  declarations: [LeadExportLogsModalComponent],
  exports: [LeadExportLogsModalComponent],
})
export class LeadExportLogsModalModule {}



// WEBPACK FOOTER //
// ./src/app/shared/components/lead-export-logs-modal/lead-export-logs-modal.module.ts